export const APP_BACKEND_FUNCTION_NAME = 'babyname-app_backend' as string;
export const APP_BACKEND_URL = 'https://babyname.matthis.link/' as string;
export const APP_BACKEND_ROLE_ARN =
  'arn:aws:iam::982619301361:role/babyname-app_backend-role' as string;
export const APP_FRONTEND_CLOUDFRONT_DOMAIN_NAME = 'static.babyname.matthis.link' as string;
export const CURRENT_ENV = '982619301361' as string;
export const REGION = 'eu-west-3' as string;
export const ACCOUNT_ID = '982619301361' as string;
export const CODE_BUCKET = 'babyname-code-20241204082134662300000002' as string;
export const DB_JSON_URL =
  'https://babyname-db-20241205072947221000000001.s3.eu-west-3.amazonaws.com/names_db.json.gz' as string;
export const PROJECTS_TABLE_NAME = 'BabyNameProjects' as string;
export const PROJECTS_BY_ACCOUNT_ID_INDEX_NAME =
  'BabyNameProjects_ByAccountId_SortedByUpdatedAt' as string;
export const PROJECTS_BY_CODE_INDEX_NAME = 'BabyNameProjects_ByCode' as string;
export const ACCOUNTS_TABLE_NAME = 'BabyNameAccounts' as string;
export const ACCOUNTS_BY_SESSION_TOKEN_INDEX_NAME = 'BabyNameAccounts_BySessionToken' as string;
export const BABYNAME_CHAT_GPT_CACHE_TABLE_NAME = 'BabyNameChatGptCache' as string;
